import { useEffect, useState } from "react";
import { ArrowUpLeft, Menu, X } from "lucide-react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { brand, navItems, text } from "../data/content";

export default function SiteHeader({ language, onLanguageToggle, onQuote }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const update = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", update, { passive: true });
    update();
    return () => window.removeEventListener("scroll", update);
  }, []);

  return (
    <header className={`site-header ${scrolled ? "is-scrolled" : ""}`} data-testid="site-header">
      <div className="page-container header-inner">
        <Link to="/" className="brand-lockup" data-testid="link-brand-logo" aria-label={text(language, brand.arLong, brand.enLong)}>
          <span className="logo-mark" aria-hidden="true" />
          <span className="brand-copy">
            <strong>{text(language, brand.ar, brand.en)}</strong>
            <small>{text(language, "للطباعة والتغليف", "PRINTING & PACKAGING")}</small>
          </span>
        </Link>

        <nav className="desktop-nav" aria-label={text(language, "التنقل الرئيسي", "Main navigation")}>
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              data-testid={item.testId}
            >
              {text(language, item.ar, item.en)}
            </NavLink>
          ))}
        </nav>

        <div className="header-actions">
          <div className="language-switcher" aria-label={text(language, "اختيار اللغة", "Language selector")}>
            <button type="button" className={language === "ar" ? "selected" : ""} onClick={() => language !== "ar" && onLanguageToggle()} data-testid="language-ar-button">ع</button>
            <span>/</span>
            <button type="button" className={language === "en" ? "selected" : ""} onClick={() => language !== "en" && onLanguageToggle()} data-testid="language-en-button">EN</button>
          </div>
          <button type="button" className="button button-small button-outline header-quote" onClick={onQuote} data-testid="header-quote-button">
            {text(language, "اطلب عرض سعر", "Request a quote")}
            <ArrowUpLeft size={15} strokeWidth={1.5} />
          </button>
          <button type="button" className="menu-toggle" onClick={() => setMenuOpen((open) => !open)} aria-label={text(language, "فتح القائمة", "Open menu")} aria-expanded={menuOpen} aria-controls="mobile-navigation" data-testid="mobile-menu-button">
            {menuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="mobile-menu" id="mobile-navigation">
          <div className="page-container mobile-menu-inner">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) => `mobile-nav-link ${isActive ? "active" : ""}`}
                data-testid={`mobile-${item.testId}`}
              >
                <span>{text(language, item.ar, item.en)}</span>
                <ArrowUpLeft size={16} strokeWidth={1.5} />
              </NavLink>
            ))}
            <button type="button" className="button button-accent mobile-quote-button" onClick={onQuote} data-testid="mobile-quote-button">
              {text(language, "ابدأ طلبك", "Start your request")}
              <ArrowUpLeft size={16} strokeWidth={1.5} />
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
